export default "__VITE_ASSET__CgTehXxS__"